import React from 'react';
import Seo from './Seo';

const TermsOfService = () => {
  return (
    <div className="page pt-32">
      <Seo
        title="Terms of Service | CompressImages.org"
        description="Review the terms for using the free CompressImages.org image compression tool."
        path="/terms-of-service"
      />

      <div className="policy-wrap">
      <h1>Terms of Service</h1>
      <div className="policy-date">Last updated: May 25, 2026</div>

      <div className="policy-body">
      <p>
        By using CompressImages.org, you agree to these terms. If you do not
        agree, do not use the website.
      </p>

      <h2>Service Description</h2>
      <p>
        CompressImages.org provides a free browser-based tool for resizing and
        compressing image files. Image processing happens on your device, and
        the website is provided for general informational and utility purposes.
      </p>

      <h2>User Responsibilities</h2>
      <ul>
        <li>Only process images that you own or have permission to use.</li>
        <li>Do not use the website for unlawful, abusive, or harmful activity.</li>
        <li>Review compressed files before publishing or sharing them.</li>
      </ul>

      <h2>Advertising and Third-Party Services</h2>
      <p>
        The website may display advertising and use third-party services such as
        hosting, analytics, and Google AdSense. Third-party links and services
        are governed by their own terms and policies.
      </p>

      <h2>No Warranty</h2>
      <p>
        The service is provided as is and as available. We do not guarantee that
        compression results will meet a specific quality, file size, or
        compatibility requirement.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        To the maximum extent allowed by law, CompressImages.org is not liable
        for indirect, incidental, or consequential damages related to use of the
        website or compressed files.
      </p>

      <h2>Changes</h2>
      <p>
        We may update these terms when the website changes. Continued use after
        updates means you accept the revised terms.
      </p>

      <h2>Contact Us</h2>
      <p>
        Questions about these terms can be sent to{' '}
        <a href="mailto:contact@compressimages.org">contact@compressimages.org</a>.
      </p>
      </div>
      </div>
    </div>
  );
};

export default TermsOfService;
